import React from 'react';

import { Container } from './Column.styles';

import { ResponsiveValue } from '../../types';

export type ColumnProps = {
  /**
   * React children nodes
   */
  children: React.ReactNode;
  /**
   * Column width span
   */
  span: number | number[];
  /**
   * Column offset
   */
  offset?: ResponsiveValue;
  /**
   * Column gutter
   */
  gutter?: ResponsiveValue;
  /**
   * Display value
   */
  display?: string | string[];
};

const Column = ({
  children,
  span,
  offset = 0,
  gutter = '5',
  display = ['block'],
}: ColumnProps) => (
  <Container
    role="cell"
    span={span}
    offset={offset}
    gutter={gutter}
    display={display}
  >
    {children}
  </Container>
);

export default Column;
